import React, { useMemo } from 'react';

import config from 'config';
import PropTypes from 'prop-types';

import EnhancedMemberModelProvider from '~/pdp/components/EnhancedMemberModelProvider';
import ProductDetailNotFoundModal from '~/pdp/components/ProductDetailNotFoundModal';
import { ProductTag } from '~/shared/constants/products';
import { getIsPlusProfile } from '~/shared/utils/getIsPlusProfile';
import { getIsPlusSizeByField } from '~/shared/utils/getIsPlusSizeByField';
import {
  useProductDetailContext,
  ModelImageProvider,
} from '~/techstyle-shared/react-components';

function ModelImageProviderWrapper({ children, profileSizes }) {
  const {
    selectionStateByProductIndex,
    product: { tagIdList },
  } = useProductDetailContext();

  const useSavagePlusSizeFallback = config.get(
    'public.brand.features.useSavagePlusSizeFallback'
  );

  const isPlusSize = useMemo(() => {
    if (selectionStateByProductIndex.length === 0) {
      return null;
    }

    const { selectedAttributes, attributeFieldTypes } =
      selectionStateByProductIndex[0];
    const selectedSize = selectedAttributes[attributeFieldTypes.SIZE];

    if (selectedSize) {
      const isPlusSizeSelected = getIsPlusSizeByField(selectedSize);

      if (isPlusSizeSelected) {
        return true;
        // We will use the `plusSize` tag id as a fallback to determine if
        // the plus images should be used. This will be necessary until the
        // `getIsPlusSizeByField` utility is updated to support SXF plus size scales
      } else if (useSavagePlusSizeFallback) {
        return tagIdList.includes(ProductTag.plusSize);
      }
    }

    const isPlusProfile = getIsPlusProfile(profileSizes);

    if (isPlusProfile) {
      return true;
    }

    return false;
  }, [
    selectionStateByProductIndex,
    profileSizes,
    useSavagePlusSizeFallback,
    tagIdList,
  ]);

  if (selectionStateByProductIndex.length === 0) {
    return <ProductDetailNotFoundModal />;
  }

  return (
    <ModelImageProvider isPlusSize={isPlusSize}>
      <EnhancedMemberModelProvider>{children}</EnhancedMemberModelProvider>
    </ModelImageProvider>
  );
}

ModelImageProviderWrapper.propTypes = {
  children: PropTypes.node,
  profileSizes: PropTypes.object,
};

export default ModelImageProviderWrapper;
